import React from 'react';

import { Avatar, AvatarProps, AvatarSize, AvatarSizes, Box } from '@aircall/tractor';
import { getEmoji } from '@dashboard/library';
import { Emoji } from 'emoji-mart';

const DEFAULT_EMOJI_SIZE = 28;
const EMOJI_SIZES = {
  [AvatarSize.LARGE]: DEFAULT_EMOJI_SIZE,
  [AvatarSize.MEDIUM]: 18,
  [AvatarSize.SMALL]: 12,
  [AvatarSize.X_SMALL]: 8,
} as Record<AvatarSizes, number>;

interface EmojiAvatarProps extends AvatarProps {
  emoji: string;
  /** Size of the outer avatar */
  size?: AvatarSizes;
}

export const EmojiAvatar = React.memo<EmojiAvatarProps>(
  ({ emoji, size = AvatarSize.LARGE, ...otherProps }) => {
    const emojiSize = EMOJI_SIZES[size] || DEFAULT_EMOJI_SIZE;

    return (
      <Avatar size={size} variant='grey' {...otherProps}>
        <Box height={emojiSize} data-test='emoji-avatar'>
          <Emoji set='apple' emoji={getEmoji(emoji)?.id || emoji} size={emojiSize} />
        </Box>
      </Avatar>
    );
  }
);
